// product-carousel.js

// Wait for jQuery and Slick to be loaded
if (typeof jQuery === 'undefined') {
  console.error('jQuery must be loaded before product-carousel.js');
}

const initProductCarousels = () => {
  const carouselOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    draggable: true, 
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    accessibility: false,
    focusOnSelect: false
  };

  // Function to initialize or reinitialize carousels
  const initializeCarousel = ($carousel) => {
    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
    }
    $carousel.slick(carouselOptions);
  };

  // Initialize all visible carousels
  const initializeVisibleCarousels = () => {
    $('.swipable-card:visible').each(function() {
      initializeCarousel($(this));
    });
  };

  // Initialize hidden carousels (for tabs/accordion)
  const initializeHiddenCarousels = () => {
    $('.swipable-card:hidden').each(function() {
      initializeCarousel($(this));
    });
  };

  // Initial initialization
  initializeVisibleCarousels();
  initializeHiddenCarousels();

 

  // Handle color swatch clicks
  $(document).on('click', '.color-swatch', function() {
    const color = $(this).attr('data-tooltip');
    const $productCard = $(this).closest('.product-card');
    const productHandle = $productCard.attr('class').match(/product-card-([^\s]+)/)?.[1];
    
    if (!productHandle) return;
    
    const carousel = $(`.product-card-${productHandle} .swipable-card:visible`);
    if (!carousel.length) return;
     

    try {
      const slides = carousel.slick('getSlick').$slides;
      if (slides?.length) {
        for(let i = 0; i < slides.length; i++) {
          if($(slides[i]).attr('data-variant-color') === color) {
            carousel.slick('slickGoTo', i);
            break;
          }
        }
      }
    } catch (error) {
      console.error('Error handling color swatch click:', error);
    }


   
  });

   // let hasDragged = false;

   //  // Track drag state
   //  carousel.on('swipe', function() {
   //    hasDragged = true;
   //    console.log('here');
   //  });
    
    // Handle navigation after drag
    // $(document).on('click', '.slick-next, .slick-prev', function() {
    //   if (hasDragged) {
    //     const carousel = $(this).closest('.swipable-card');
    //     carousel.slick('setPosition');
    //     hasDragged = false;
    //   }
    // });

  // Handle layout switch
  $('collection-layout-switch button').on('click', function() {
    // Multiple attempts to catch the layout change
    setTimeout(initializeVisibleCarousels, 0);
    setTimeout(initializeVisibleCarousels, 50);
    setTimeout(initializeVisibleCarousels, 100);
  });

  // Handle tab changes in featured collections
  // $('.featured-collections-carousel__item').on('click', function() {
  //   setTimeout(() => {
  //     $('.swipable-card:visible').each(function() {
  //       const $carousel = $(this);
  //       if ($carousel.hasClass('slick-initialized')) {
  //         $carousel.slick('setPosition').slick('refresh');
  //       } else {
  //         initializeCarousel($carousel);
  //       }
  //     });
  //   }, 200);
  // });

  // Observer for layout changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.classList.contains('is-active')) {
        initializeVisibleCarousels();
      }
    });
  });

  // Observe layout switch buttons
  document.querySelectorAll('collection-layout-switch button').forEach(button => {
    observer.observe(button, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // Handle carousel navigation clicks
  $('carousel-navigation button').on('click', function() {
    const buttonId = $(this).attr('id');
    setTimeout(() => {
      $(`.featured-collections-carousel__item[data-tab-id="${buttonId}"]`)
        .find('.product-card')
        .first()
        .find('.color-swatch')
        .first()
        .trigger('click');
    }, 200);
  });

  // Add pagination handling
  $(document).on('page:load page:change', initializeVisibleCarousels);
  
  // Handle Shopify-specific section events
  $(document).on('shopify:section:load', initializeVisibleCarousels);
  $(document).on('shopify:section:select', initializeVisibleCarousels);
  
  // Handle URL changes for pagination
  let lastUrl = window.location.href;
  const urlObserver = new MutationObserver(() => {
    const currentUrl = window.location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      setTimeout(initializeVisibleCarousels, 300);
    }
  });

  urlObserver.observe(document, {
    subtree: true,
    childList: true
  });
};

// Initialize when document is ready
$(document).ready(() => {
  try {
    if (typeof $.fn.slick === 'undefined') {
      console.error('Slick carousel must be loaded before product-carousel.js');
      return;
    }
    initProductCarousels();

    // Additional initialization for dynamic page loads
    $(document).on('turbolinks:load', initProductCarousels);
    $(document).on('pjax:end', initProductCarousels);
  } catch (error) {
    console.error('Error initializing product carousels:', error);
  }
});